
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ux-designer",
      function () {
        return require("private-next-pages/ux-designer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ux-designer"])
      });
    }
  